import React, {useRef, useEffect} from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// força alta resolução em todos os gráficos
ChartJS.defaults.devicePixelRatio = 2; // pode testar 3 se quiser ainda mais

function BarGraph({ data, text, onImageReady }) {
  const chartRef = useRef(null);

  // Sempre que o gráfico mudar, envia a imagem pro pai
useEffect(() => {
  setTimeout(() => {  
    if (chartRef.current && onImageReady) {
      const canvas = chartRef.current.canvas || chartRef.current.ctx?.canvas;

      if (canvas) {
        const imgBase64 = canvas.toDataURL("image/png");
        onImageReady(imgBase64);
      }
    }
  }, 2000);
}, [data, onImageReady]);

  // Clonar dados para evitar mutação direta
  const combined = data.labels.map((label, i) => ({
    label,
    value: data.datasets[0].data[i],
  }));

  // Ordenar os dados (decrescente por valor)
  combined.sort((a, b) => b.value - a.value);

  // Reconstruir estrutura ordenada
  const sortedData = {
    labels: combined.map((item) => item.label),
    datasets: [
      {
        ...data.datasets[0],
        data: combined.map((item) => item.value),
        barThickness: 20,
      },
    ],
  };

const options = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text,
      font: { size: 14 },
      color: "#333",
      padding: { top: 10, bottom: 20 },
    },
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      bodyColor: "#fff",
    },
    datalabels: {
      anchor: 'end',
      align: 'end',
      color: '#333',
      font: {
        size: 10,
        weight: 'bold',
      },
      formatter: (value) => value.toLocaleString('pt-BR'),
    },
  },
  scales: {
    x: {
      beginAtZero: true,
      ticks: { color: "#333", font: { size: 9 } },
      grid: { drawBorder: false, color: "#ddd" },
    },
    y: {
      ticks: { color: "#333", font: { size: 12 } },
      grid: { display: false },
    },
  },
};

  return <Bar ref={chartRef} data={sortedData} options={options} />;
}

export default BarGraph;